<template>
    <div v-loading="loading" class="new-paintings">
        <h3 class="text-center text-base xl:text-xl">New Paintings & Projects</h3>
        <el-carousel :autoplay="true" :interval="8000" :loop="true" trigger="click" :arrow="paintings.length > 1 ? 'hover' : 'never'" indicator-position="none">
            <el-carousel-item v-for="item in paintings" :key="`painting-${item.id}`">
                <p class="mb-2 text-center text-sm">
                    {{ item.name }}<br />
                    {{ $t('difficulties')[item.difficulty] }}, {{ $t('durations')[item.duration] }}
                </p>
                <responsive-image type="painting" :media="item.photo" :title="item.name" sizes="300px"></responsive-image>
            </el-carousel-item>
        </el-carousel>
        <p class="mt-4 text-center"><a :href="route('gallery')" class="button button-sm button-turquoise">View Gallery</a></p>
    </div>
</template>

<script>
    import axios from '@/axios';
    import ResponsiveImage from '@/components/ResponsiveImage.vue';

    export default {
        name: 'NewPaintings',
        components: {
            ResponsiveImage,
        },
        filters: {},
        mixins: [],
        props: {},
        data() {
            return {
                loading: true,
                paintings: [],
            };
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                this.loading = true;
                axios.get(route('new.paintings')).then((response) => {
                    this.paintings = response.data.data;
                    this.loading = false;
                });
            },
        },
    };
</script>

<style>
    .new-paintings .el-carousel__container {
        height: 36rem;
    }

    @media (min-width: 1024px) {
        .new-paintings .el-carousel__container {
            height: 24rem;
        }
    }
</style>
